import Vue from 'vue'

Vue.filter('formatName', (text, name) => {
    return text.replace("[nome]", name)
})
